<template>
	<div ref="banner" class="banner">
		<div class="swiper_box">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<div class="img_box">
							<img src="../../../../assets/home_banner.png" alt="">
						</div>
						<div class="mask_box" data-swiper-parallax="-130%">
							<h1 class="title text_theme">让视觉训练</h1>
							<h3 class="sub_title text_theme">走进千家万户<span v-if="false">01/05</span></h3>
							<div class="circles">
								<i></i>
							</div>
							<!-- <div class="button">
								<button>查看详情</button>
							</div> -->
						</div>
					</div>
					<div v-for="v in data" :key="v.id" class="swiper-slide" @click="handleItemClick(v)">
						<div class="img_box">
							<img :src="v.pictureUrl" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<ul class="swiper_control">
			<li :class="{'bg_theme': active_index == 0}" data-index="0" @click="handleControlClick"></li>
			<li v-for="(v, i) in data" :key="v.id" :class="{'bg_theme': active_index == i + 1}" :data-index="i+1" @click="handleControlClick"></li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Array,
				default() { return []; }
			}
		},
		mounted() {
			this.lock = true;
			this.initSwiper();
			this.addEventListen();
		},
		data() {
			return {
				active_index: 0
			}
		},
		methods: {
			/***************** @Events **********************/
			// 点击图片
			handleItemClick(data) {
				let openType = data.openType;
				let link = data.link;
				(openType == 1 && link) && this.$emit('onClick', link);
				(openType == 2 && link) && window.open(link);
			},
			// 点击指示器
			handleControlClick(e) {
				let index = parseInt(e.target.dataset.index);
				!this.lock && this.swiper_instance.slideTo(index);
			},
			
			/***************** @Function **********************/
			// 初始化swiper
			initSwiper() {
				const that = this;
				this.swiper_instance = new this.Swiper ('.banner .swiper-container', {
					speed: 300,
					// loop: true,
					allowTouchMove: false,
					parallax: true,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					on: {
						transitionStart: function() {
							that.lock = true;
							let slides = this.slides;
							let imgBox = slides.eq(this.previousIndex).find('.img_box');
							imgBox.css('opacity', '0');
						},
						transitionEnd: function() {
							// console.log(this.activeIndex);
							that.active_index = this.activeIndex;
							this.slides.eq(this.activeIndex).find('.img_box').css('opacity', '1');
							that.lock = false;
						},
						init: function() {
							this.emit('transitionEnd'); //在初始化时触发一次transitionEnd事件
						}
					}
				});
			},
			// 添加事件
			addEventListen() {
				const that = this;
				//鼠标移上去禁止自动切换
				that.$refs.banner.onmouseenter = () => {
					that.swiper_instance && that.swiper_instance.autoplay.stop();
				}
				
				//鼠标离开开始自动切换
				that.$refs.banner.onmouseleave = () => {
					that.swiper_instance && that.swiper_instance.autoplay.start();
				}
			}
		},
		watch: {
			data() {
				this.$nextTick(() => {
					this.lock = true;
					this.swiper_instance && this.swiper_instance.destroy();
					this.initSwiper();
				});
			}
		}
	}
</script>

<style scoped>
	.banner{ position: relative;height: 820px; }
	.banner .swiper-container{ height: 100%; }
	.banner .swiper_box{ position: absolute;width: 1920px;height: 820px;top: 0;left: 50%;margin-left: -960px;background-color: #f5f5f5;overflow: hidden; }
	.banner .swiper-wrapper{ transition-delay: .3s;transition-timing-function: cubic-bezier(0.5, 0, 0, 1); }
	.banner .img_box{ position: absolute;top: 0;left: 0;right: 0;bottom: 0;transition-property: opacity;transition-duration: .3s;transition-timing-function: cubic-bezier(0.5, 0, 0, 1);opacity: 0;overflow: hidden; }
	.banner .img_box img{ display: block;width: 100%;height: 100%; }
	.banner .mask_box{ position: absolute;width: 1200px;top: 0;left: 50%;margin-left: -600px;padding: 164px 0 0 0;transition-delay: .3s; }
	.banner .title{ font-size: 36px;line-height: 50px; }
	.banner .sub_title{ position: relative;font-size: 60px;line-height: 76px; }
	.banner .sub_title::after{ content: "";display: block;position: absolute;width: 100%;height: 1px;bottom: -16px;left: 0;background-color: #2b53c6; }
	.banner .sub_title span{ display: block;position: absolute;font-size: 18px;right: 0;bottom: 0;line-height: 30px; }
	.banner .circles{ margin-top: 120px; }
	.banner .circles i{ display: inline-block;width: 41px;height: 53px;background-image: url(../../../../assets/circles_1.png);vertical-align: top; }
	.banner .button{ margin-top: 150px; }
	.banner .button button{ padding: 0 60px;border-radius: 25px;font-size: 24px;color: #ffb805;line-height: 50px; }
	.banner .swiper_control{ position: absolute;z-index: 9;width: 1200px;bottom: 94px;left: 50%;margin-left: -600px;text-align: right; }
	.banner .swiper_control li{ display: inline-block;width: 15px;height: 15px;margin: 0 0 0 5px;border-radius: 50%;background: #fff;vertical-align: top;cursor: pointer; }
</style>
